import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";
import ImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/ImageElement.vue";
import VideoElement
  from "%/dynamic-component-editor/standard-elements/video-element/VideoElement.vue";
import ButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/ButtonElement.vue";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";
import SpacerElement
  from "%/dynamic-component-editor/standard-elements/spacer-element/SpacerElement.vue";
import AdUnit from "%/dynamic-component-editor/standard-elements/AdUnit.vue";
import Icon from "%/dynamic-component-editor/standard-elements/Icon.vue";
import ProgressBar from "%/dynamic-component-editor/standard-elements/progress-bar/ProgressBar.vue";
import FeedSeparatorLabel from "%/dynamic-component-editor/standard-elements/FeedSeparatorLabel.vue";
import DynamicComponentElement
  from "%/dynamic-component-editor/standard-elements/dynamic-component-element/DynamicComponentElement.vue";
import UpsellElement
  from "%/dynamic-component-editor/standard-elements/upsell-element/UpsellElement.vue";
import Feed from "%/dynamic-component-editor/standard-elements/Feed.vue";
import QuestionnaireElement from "+/QuizzesPolls/Components/QuestionnaireElement.vue";
import OptionStateElement from "+/QuizzesPolls/Components/OptionStateElement.vue";
import CheckboxStateElement from "+/QuizzesPolls/Components/CheckboxStateElement.vue";
import RequiredAnswersGate from "+/QuizzesPolls/Components/RequiredAnswersGate.vue";
import StepProgressElement from "+/QuizzesPolls/Components/StepProgressElement.vue";
import FeedV2Element
  from "%/dynamic-component-editor/standard-elements/dynamic-app-elements/display/FeedV2Element.vue";
import PageHeader from "%/dynamic-component-editor/standard-elements/PageHeader.vue";
import PageFooter from "%/dynamic-component-editor/standard-elements/PageFooter.vue";
import SubscribeToNewsletter
  from "%/dynamic-component-editor/standard-elements/SubscribeToNewsletter.vue";
import UserMenuAndJoin
  from "%/dynamic-component-editor/standard-elements/UserMenuAndJoin.vue";
import SingleStoryCard
  from "%/dynamic-component-editor/standard-elements/SingleStoryCard.vue";
import StoryContextCard
  from "%/dynamic-component-editor/standard-elements/StoryContextCard.vue";
// Publication-bound elements that existed in the legacy builder's General palette but were left
// unregistered when the builder was migrated to this tree (the element files were copied over but
// never added to any entity's element list, so they never appeared in the new Studio palette).
import PublicationLogo
  from "%/dynamic-component-editor/standard-elements/PublicationLogo.vue";
import PrimaryNavigation
  from "%/dynamic-component-editor/standard-elements/navigation/PrimaryNavigation.vue";
import DynamicQuickPost
  from "%/dynamic-component-editor/standard-elements/quick-post/DynamicQuickPost.vue";
import CreateArticleButton
  from "%/dynamic-component-editor/standard-elements/articles/elements/CreateArticleButton.vue";
import SavedPosts from "%/dynamic-component-editor/standard-elements/SavedPosts.vue";

export default class LegacyGeneralEntity extends LegacyEntity {

  // DynamicComponentElement is included here so its Vue component lands
  // in `availableElementVueComponents` and the element registry — which
  // DynamicElement / the production renderer both read. It's marked
  // `hidden` so the palette-group renderer filters it out; user-created
  // reusable components surface instead via the Elements panel's
  // Components feed (see ComponentSidebarItem), each dropping as a
  // DynamicComponentElement whose referenced-component-id is pre-set.
  //
  // Feed is registered here so Studio destinations can drop a SmartFeed
  // primitive on any standard page (HomePage, etc.). FanWeb registers
  // its own Feed.vue out of `dynamic-components/standard-elements/`
  // via main-vue.js so both apps end up with a `Feed` entry — that's
  // fine; the Studio path resolves through this entity.
  static get elements() {
    return [
      ImageElement,
      VideoElement,
      ButtonElement,
      TextElement,
      UrlElement,
      SpacerElement,
      AdUnit,
      Icon,
      ProgressBar,
      Feed,
      QuestionnaireElement,
      OptionStateElement,
      CheckboxStateElement,
      RequiredAnswersGate,
      StepProgressElement,
      // FeedV2 — the publication-feeds element: drop it, pick WHICH publication
      // feed (stories/shows/events/…) in the inspector, then the Card Component.
      FeedV2Element,
      // Renders the label of the feed separator it sits in. `hidden` keeps it in
      // the element REGISTRY (so components authored before the gate existed
      // still resolve it) while the palette offers it only on a component that
      // declares the feedSeparator context -- see helpers/feed-separator-label.js
      // and the Section Heading group in DynamicComponentEditorElementsPanel.
      { ...FeedSeparatorLabel, hidden: true },
      // DC-host elements — each embeds a whole reusable DynamicComponent
      // and now exposes the standard picker (see `DcHostPickerMixin`) so
      // an author can swap in their own DC, same path Feed uses for its
      // row template via `feed-row-component-id`.
      PageHeader,
      PageFooter,
      SubscribeToNewsletter,
      UserMenuAndJoin,
      SavedPosts,
      SingleStoryCard,
      // Same card, sourced from a named Story context instead of a hand-picked
      // story — that's what makes "Resume Story" renderable as a card.
      StoryContextCard,
      PublicationLogo,
      PrimaryNavigation,
      DynamicQuickPost,
      CreateArticleButton,
      UpsellElement,
      { ...DynamicComponentElement, hidden: true },
    ];
  }
}
